"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shakaInternal = require("shaka-player");
var createAbrManagerDazn_1 = require("./Abr/createAbrManagerDazn");
var createRetry_1 = require("./Abr/createRetry");
var createStateMachine_1 = require("./Abr/createStateMachine");
var State_1 = require("./Abr/State/Constants/State");
var createBandwidthEstimation_1 = require("./Bandwidth/createBandwidthEstimation");
var createHttpPlugin_1 = require("./Network/createHttpPlugin");
var createHttpRequestMonitor_1 = require("./Network/createHttpRequestMonitor");
var registerHttpPlugin_1 = require("./Network/registerHttpPlugin");
var registerHttpRequestMonitorCallbacks_1 = require("./Network/registerHttpRequestMonitorCallbacks");
var createPlayerConfig_1 = require("./Player/createPlayerConfig");
var shutdownConfig_1 = require("./shutdownConfig");
function initConfig(params) {
    var videoElement = params.videoElement, player = params.player, baseConfig = params.baseConfig, plugins = params.plugins;
    var shaka = params.shaka;
    if (shaka === undefined) {
        shaka = shakaInternal;
    }
    var bandwidthEstimation = createBandwidthEstimation_1.default(shaka);
    var httpRequestMonitor = createHttpRequestMonitor_1.default(shaka, bandwidthEstimation);
    var stateMachine = createStateMachine_1.default();
    var retry = createRetry_1.default();
    var abrManager = createAbrManagerDazn_1.default(httpRequestMonitor, stateMachine, retry);
    registerHttpRequestMonitorCallbacks_1.default(httpRequestMonitor, abrManager, videoElement, player);
    var httpPlugin = createHttpPlugin_1.default(shaka, httpRequestMonitor);
    registerHttpPlugin_1.default(shaka, httpPlugin);
    var config = createPlayerConfig_1.default(abrManager, shaka, player, baseConfig);
    player.configure(config);
    if (plugins) {
        var pluginParams_1 = {
            abrManager: abrManager,
            httpRequestMonitor: httpRequestMonitor,
            stateMachine: stateMachine
        };
        plugins.forEach(function (plugin) {
            plugin.initPlugin(pluginParams_1);
        });
    }
    httpRequestMonitor.emitBandwidthEstimate();
    abrManager.setInitialState(State_1.default.REBUFFER);
    var on = function (event, handler) {
        switch (event) {
            case 'heuristic-state':
                var heuristicHandler = function (label) {
                    handler({
                        label: label
                    });
                };
                var unsubscribe = stateMachine.on('state', heuristicHandler);
                var currentState = stateMachine.getCurrentState();
                if (currentState) {
                    heuristicHandler(currentState.label);
                }
                return unsubscribe;
        }
    };
    var context = {
        shaka: shaka,
        httpRequestMonitor: httpRequestMonitor,
        on: on,
        plugins: plugins || [],
        destroy: function () {
            shutdownConfig_1.default(context);
        },
        setBandwidthEstimate: function (bandwidthEstimate) {
            bandwidthEstimation.setBandwidthEstimate(bandwidthEstimate);
            httpRequestMonitor.emitBandwidthEstimate();
        },
        setState: function (state, timeoutMilliseconds) {
            if (timeoutMilliseconds === void 0) { timeoutMilliseconds = 0; }
            if (abrManager.hasVariants()) {
                abrManager.setState(state, timeoutMilliseconds);
            }
        },
        STATE_PANICMODE: State_1.default.PANICMODE,
        STATE_REBUFFER: State_1.default.REBUFFER,
        STATE_STEADY: State_1.default.STEADY
    };
    return context;
}
exports.default = initConfig;
//# sourceMappingURL=initConfig.js.map